import * as actionTypes from "../actions/actionTypes";
import {updateObject} from "../../shared/utility";

const initialState = {
    ingredients: null,
    totalPrice: 8,
    error: false,
    building: true
};

const INGREDIENT_PRICES = {
    salad: 1,
    cheese: 1,
    meat: 4,
    bacon: 1.50
};

const addIngredient = (state, action) => {
    const updatedIngredient = {[action.ingredientName]: state.ingredients[action.ingredientName] + 1};
    const updatedIngredients = updateObject(state.ingredients, updatedIngredient )
    const updatedState = {
        ingredients: updatedIngredients,
        totalPrice: state.totalPrice + INGREDIENT_PRICES[action.ingredientName],
        building: true
    }
    return updateObject(state, updatedState);
}

const removeIngredient = (state, action) => {
    const updatedIngredient = {[action.ingredientName]: state.ingredients[action.ingredientName] - 1};
    const updatedIngredients = updateObject(state.ingredients, updatedIngredient )
    const updatedState = {
        ingredients: updatedIngredients,
        totalPrice: state.totalPrice - INGREDIENT_PRICES[action.ingredientName],
        building: true
    }
    return updateObject(state, updatedState);
}

const setIngredients = (state, action) => {
    return updateObject(state, {
        ingredients: {
            bacon: action.ingredients.bacon,
            salad: action.ingredients.salad,
            cheese: action.ingredients.cheese,
            meat: action.ingredients.meat
        },
        error: false,
        totalPrice: 8,
        building: true
    });
}

const fetchIngredientsFailed = (state, action) => {
    return updateObject(state, {error: true, building: false})
}

const burgerBuilderReducer = (state= initialState, action)=> { 
    switch(action.type){
        case actionTypes.ADD_INGREDIENT: 
            return addIngredient(state, action);
        case actionTypes.REMOVE_INGREDIENT:
            return removeIngredient(state, action);
        case actionTypes.SET_INGREDIENTS:
            return setIngredients(state, action);
        case actionTypes.FETCH_INGREDIENTS_FAILED:
            return fetchIngredientsFailed(state, action);
        default:
        return state;
    }
};

export default burgerBuilderReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/burgerBuilder.js